import { randomBytes } from "node:crypto"

/** Sin vocales (no forma palabras) ni 0/1/O/I (se confunden al dictarlo). */
export const REFERRAL_CODE_ALPHABET = "BCDFGHJKMNPQRSTVWXZ23456789"
export const REFERRAL_CODE_LENGTH = 6
/** Misma regla que el CHECK de referral_partners.code y que la cookie. */
export const REFERRAL_CODE_RE = /^[BCDFGHJKMNPQRSTVWXZ2-9]{6}$/

/**
 * Un código nuevo. `randomByte` devuelve un entero >= 0; por default bytes
 * criptográficos. Sesgo de módulo: 256 % 27 = 13, despreciable para un código
 * que además se verifica único en la base (reintento ante 23505).
 */
export function generateReferralCode(randomByte: () => number = defaultRandomByte): string {
  let out = ""
  for (let i = 0; i < REFERRAL_CODE_LENGTH; i++) {
    out += REFERRAL_CODE_ALPHABET[Math.abs(randomByte()) % REFERRAL_CODE_ALPHABET.length]
  }
  return out
}

function defaultRandomByte(): number {
  return randomBytes(1)[0]
}

export function isReferralCode(v: unknown): v is string {
  return typeof v === "string" && REFERRAL_CODE_RE.test(v)
}

/**
 * El link corto que el socio comparte: `<base>/ref/<CÓDIGO>`. Misma base que el
 * resto de los links públicos (NEXT_PUBLIC_APP_URL, o useredy.com).
 */
export function referralLink(code: string): string {
  const base = (process.env.NEXT_PUBLIC_APP_URL ?? "https://useredy.com").replace(/\/+$/, "")
  return `${base}/ref/${code}`
}
